<template>
  <p class="app-media-credit-line" :title="value">
    {{ value }}
  </p>
</template>

<script>
export default {
  name: 'AppMediaCreditLine',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.app-media-credit-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  margin-bottom: 0;
  padding: 6px 8px;
  font-size: 12px;
  color: vars.$c-total-white;
  background: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
